import React, { Component } from 'react';
import confirm from '@/page/components/confirm';
import DocumentTitle from 'react-document-title';
import API from '@/api/api';
import queryString from 'query-string';
import zhCN from 'antd/es/locale/zh_CN';
import { message, Table, Button, Input, ConfigProvider, Select } from 'antd';
import ManageItem from './item/manage';
import './index.less';

const { Option } = Select;
let confirmKey = 0;
const columns = [
    {
        title: '歌曲',
        dataIndex: 'musicName',
        key: 'musicName',
    },
    {
        title: '歌手',
        dataIndex: 'singer',
        key: 'singer',
    },
    {
        title: '专辑',
        dataIndex: 'album',
        key: 'album',
    }
];
let circleId;
export default class extends Component {
    state = {
        // 第三方歌曲列表
        musicList: [],
        // 已添加的第三方歌曲id列表
        addThirdMusicIds: new Set(),
        selectedRows: [],
        selectedRowKeys: [],
        // 搜索关键词
        keyword: '',
        pagination: {
            hideOnSinglePage: true,
            showQuickJumper: false,
            showSizeChanger: false,
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`
        }
    }

    operateColumn = {
        title: '操作',
        render: (text, record, index) => {
            const { addThirdMusicIds } = this.state;
            if (addThirdMusicIds.has(record.thirdMusicId)) {
                return <Button type='primary' disabled>已添加</Button>
            }
            return <Button type='primary' onClick={() => this.addMusic([record])}>添加</Button>
        }
    }

    componentDidMount() {
        const parsed = queryString.parse(window.location.search);
        circleId = parsed.circleId;
    }

    fetchData = async () => {
        const { keyword, pagination } = this.state;
        const result = await API.musicSearch({
            keyword, circleId,
            pageNo: pagination.current, pageSize: pagination.pageSize
        });
        if (!result) return;
        if (result.status === '1') {
            const { datas: musicList, totalNum, addThirdMusicIds } = result.data;
            pagination.total = Number(totalNum);
            this.setState({ musicList, pagination, addThirdMusicIds: new Set(addThirdMusicIds) });
            if (!musicList || musicList.length === 0) {
                message.info('没有搜到任何结果');
                return;
            }
        } else {
            message.error(result.msg);
        }
    }

    getItemList = async () => {
        const result = await API.itemList({ circleId });
        if (!result) return;
        if (result.status !== '1') {
            message.error(result.msg);
            return;
        }
        return result.data;
    }

    manageItem = async (itemList, musicInfo) => {
        const content = (
            <ManageItem itemList={itemList} circleId={circleId} showManage={(list) => this.manageItem(list, musicInfo)} />
        );
        await confirm(content, { title: '管理栏目' })
        this.addMusic(musicInfo);
    }

    pickItem = async (musicInfo) => {
        const itemList = await this.getItemList();
        return new Promise(async resolve => {
            let selectedItemId = itemList && itemList[0] && itemList[0].itemId;
            const key = `${confirmKey++}`;
            const content = (
                <div key={key}>
                    选择栏目
                    <Select style={{ marginLeft: '10px', width: "200px" }}
                        defaultValue={selectedItemId}
                        onChange={value => selectedItemId = value}>
                        {itemList.map(o => <Option key={o.itemId} value={o.itemId}>{o.itemName}</Option>)}
                    </Select>
                    <Button type='link' onClick={() => {
                        resolve();
                        this.manageItem(itemList, musicInfo);
                    }}>管理栏目</Button>
                </div>
            );
            if (await confirm(content, { title: '添加歌曲' })) {
                resolve(selectedItemId);
            }
            resolve();
        });
    }

    addMusic = async musicInfo => {
        if (!musicInfo || musicInfo.length === 0) {
            message.info('请先选择歌曲');
            return;
        }
        const itemId = await this.pickItem(musicInfo);
        if (!itemId) {
            return;
        }
        const result = await API.musicAdd({
            circleId, itemId,
            musicInfo: JSON.stringify(musicInfo)
        });
        if (result && result.status === '1') {
            message.info('添加成功');
            // this.setState({ selectedRowKeys: [], selectedRows: [] });
            // this.fetchData();
            setTimeout(() => {
                this.props.history.go(-1);
            }, 1000);
        } else {
            message.error((result && result.msg) || '添加失败');
        }
    }

    onKeywordChange = t => {
        this.setState({ keyword: t.target.value });
    }

    handleTableChange = pn => {
        let { pagination } = this.state;

        pagination.current = pn.current;
        this.setState({
            pagination
        }, () => {
            this.fetchData();
        });
    };

    doSearch = () => {
        let { keyword, pagination } = this.state;
        if (!keyword) {
            message.info('请输入关键词');
            return;
        }
        pagination.current = 1;
        this.setState({
            pagination
        }, () => {
            this.fetchData();
        });
    }

    getTable = () => {
        const { musicList, selectedRowKeys, pagination, addThirdMusicIds } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({ selectedRowKeys, selectedRows })
            },
            getCheckboxProps: record => ({
                disabled: addThirdMusicIds.has(record.thirdMusicId),
                name: '' + record.thirdMusicId
            })
        };
        if (musicList && musicList.length) {
            return (
                <Table
                    bordered={true}
                    className="mt10"
                    columns={[...columns, this.operateColumn]}
                    rowSelection={rowSelection}
                    dataSource={musicList}
                    pagination={pagination}
                    // scroll={{ x: true, scrollToFirstRowOnChange: true }}
                    onChange={this.handleTableChange}
                    rowKey={(row) => row.thirdMusicId} />);
        }
        return '';
    }

    render() {
        const {
            keyword, selectedRows
        } = this.state;
        const tableEl = this.getTable();
        return (
            <DocumentTitle title='添加歌曲'>
                <ConfigProvider locale={zhCN}>
                    <main className='page_manage_add'>
                        <div className="title">添加歌曲</div>
                        <div className='search_box mt10'>
                            <Input value={keyword} style={{ width: '240px' }}
                                onChange={this.onKeywordChange} onPressEnter={this.doSearch}
                                placeholder="歌曲\歌手\专辑"></Input>
                            <Button className='ml10' onClick={this.doSearch}>搜索</Button>
                        </div>
                        {tableEl}
                        {tableEl && <Button className='mt10' onClick={() => this.addMusic(selectedRows)}>添加全部已选</Button>}
                    </main>
                </ConfigProvider>
            </DocumentTitle>
        );
    }
}